import { Creators as UpdaterCreators } from "model/updater"
import { Creators } from "./model"
import { Creators as TokenCreators } from "model/token"
import createModule from "../createModule"
import { Creators as DialogCreators } from "modules/dialog/model"
import withOutletContext from "hocs/withOutletContext"
import { showEmailSubscriptions, getMfaSecret, getQrCode, getMfaDevices } from "./selectors/index"
import view from "./view"

export default withOutletContext(createModule({
  view,
  mapStateToProps: (state, props) => ({
    ...state.user,
    ...state.modules.userProfile,
    showEmailSubscriptions: showEmailSubscriptions(state, props),
    mfaSecret: getMfaSecret(state, props),
    qrCode: getQrCode(state, props),
    mfaDevices: getMfaDevices(state, props),
  }),
  actions: {
    update: UpdaterCreators.update,
    checkAuthType: TokenCreators.checkAuthType,
    openDialog: DialogCreators.open,
    ...Creators,
  },
}))
